import React from "react";
import PropTypes from "prop-types";

import Shimmer from "@techsoftware/happay-widgets/Shimmer";
import Style from "../../constants/style";
import MenuItem from "../customMenuItem";
import i18n from "./../../i18nNext";

const ActionShimmer = props => {
    const rows = [];
    for (let i = 0; i < props.row; i++) {
        rows.push(
            <div style={{ margin: 4 }} key={`shimmer-row-${i}`}>
                <Shimmer width={50} height={15} />
            </div>
        );
    }
    return (
        <div style={{ textAlign: "center" }}>
            <div style={{ textAlign: "left" }}>
                <MenuItem
                    key={`${i18n.t("btn.view")}-${props.uniqKey}`}
                    onClick={props.onClick}
                    primaryText={i18n.t("btn.view")}
                    style={Style.menuItemStyle}
                />
            </div>
            {rows}
        </div>
    );
};

ActionShimmer.defaultProps = {
    uniqKey: `190920`,
    onClick: () => {},
    row: 3
};

ActionShimmer.propTypes = {
    uniqKey: PropTypes.string,
    onClick: PropTypes.func
};
export default ActionShimmer;
